import { LogLevel } from '@azure/msal-browser';
import packageInfo from '../../package.json';

export const environment = {
  production: true,
  version: packageInfo.version,
  apiServerUrl: 'https://lbgateway.littlebit.ch',

  adminRole: 'Admin',
  clientAdminRole: 'ClientAdmin',
  apiClientId: 'Stargate',
  localStorageToken: 'token',
  localStorageTokenExpiration: 'tokenExpiration',
  localStorageRefreshToken: 'refreshToken',
  localStorageUserInfo: 'userInfo',
  localStorageIsSidebarPinned: 'isSidebarPinned',
  localStorageLastTheme: 'lastTheme',
  supportedLanguages: 'en,de',
  alarmReloadInterval: 2000,
  idleTimeoutInSeconds: 900,
  localStorageActivityTimestamp: 'activityTimestamp',
  allowBrowserTranslation: true,
  sftpPort: 22,
  sftpServerUrl: 'sftp://lbgateway.littlebit.ch',
  assetStorageRoute: '/api/Asset/AssetStorage/',
  productAssetRoute: '/api/Asset/ProductAsset/',
  manualImportRoute: '/api/import/ManualImport/',
  assetCollectionPublicViewApiRoute: '/api/Asset/AssetCollectionPublicView/',
  avoidAutoLogout: false,

  syncfusionKey: 'Ngo9BigBOggjHTQxAR8/V1JGaF5cXGpCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH1ccnRQRGJdWEZ+X0ZWZ0k=',
  msalConfig: {
    auth: {
      clientId: 'f159cf14-5c84-4636-847f-e12dbab89f27',
      authority: 'https://login.microsoftonline.com/7a1c477c-7f20-4550-a6f6-ad36c81e73e9',
    },
    logLevel: LogLevel.Error
  },
  azureLoginApi:{
    subUri: '/TokenWithAzurePrincipal',
    scopes: ['api://91222548-f15b-4625-9fd4-43f0cfd79bbd/Stargate.AzureLogin']
  },
  activateVendorScoreCardFeature: true
};
